import { render, staticRenderFns } from "./link-tile.vue?vue&type=template&id=588bb836&scoped=true"
import script from "./link-tile.vue?vue&type=script&lang=js"
export * from "./link-tile.vue?vue&type=script&lang=js"
import style0 from "./link-tile.vue?vue&type=style&index=0&id=588bb836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588bb836",
  null
  
)

export default component.exports